/**
 * answer-menu-item.js
 */

import React from 'react';
import { Tab, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation } from 'react-router-dom';
import { Types } from 'utils/constants';
import { UserContext } from 'contexts/user/user-context';
import { makeLocation } from 'utils/routing';
import useRecordStore from 'contexts/record-store';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import RouteLink from 'routing/route-link';
import AnswerIcon from '../icon';


const useStyles = makeStyles(theme => ({
  handlerName: {
    fontSize: theme.typography.sizes[1],
    fontWeight: 500,
    color: theme.palette.grey.colors[6],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& span': {
      padding: `0 ${theme.spacing(1)}`
    }
  }
}));


export default function AnswerMenuItem(props) {
  const {
    id,
    handlerId,
    answer: answerProp,
    type,
    basePath,
    membership,
    showK9Prefix,
    showHandlerName,
    ...rest
  } = props;
  const classes = useStyles();
  const location = useLocation();
  const recordStore = useRecordStore();
  const { user } = React.useContext(UserContext);
  const answerId = id;
  const answerRecord = recordStore.useRecord(Types.Record.ANSWER, id);
  const answer = answerProp || answerRecord.get();

  if (!answer) return null;

  const exerciseId = answer ? answer.exerciseId : 0;
  const pathItemName = !user.role.isHandler
    ? 'viewHandlerAnswer'
    : user.role.status.isActive && answer.canComplete
      ? 'editAnswer'
      : 'viewAnswer';
  const pathParams = { exerciseId, answerId, handlerId };
  const dogName = !answer 
    ? ''
    : !showK9Prefix || answer.dog.name.toLowerCase().includes('k9')
      ? answer.dog.name
      : `K9 ${answer.dog.name}`;
  const disabled = props.disabled || 
    (user.role.isHandler
      ? exerciseId === 0
      : false);

  
  return (
    <>
      {answer &&
      <>

        {/* type: drawer-menu-item */}
        {type === 'drawer-menu-item' &&
        <DrawerMenuItem
          key={`answer-${answerId}`}
          id={`answer-${answerId}`}
          icon={<AnswerIcon 
            answer={answer} 
            membership={membership}
            allowRejected
          />}
          label={<div className={`flex-hc`}>
            <Typography>{dogName}</Typography>
            {showHandlerName && <><Typography className={classes.handlerName}><span>•</span>{answer.handler.name}</Typography></>}
          </div>}
          to={makeLocation(
            basePath,
            'training',
            pathItemName, 
            pathParams,
            location
          )}
          {...rest}
        />}

        {/* type: tab */}
        {type === 'tab' &&
        <Tab
          component={RouteLink}
          label={<>
            <AnswerIcon 
              answer={answer} 
              membership={membership} 
              label={dogName}
              showTooltip
              allowRejected
            />
          </>}
          basePath={basePath}
          pathSectionName='training'
          pathItemName={pathItemName}
          pathParams={pathParams}
          disabled={disabled}
          {...rest}
        />}

      </>}
    </>
  );
}